<template>
    <div>
        <div
            v-for="section in sections"
            :key="section"
            class="uk-margin-bottom"
        >
            <h5>{{ section }}</h5>

            <div class="lam-hierarchical-lists">
                <ul class="uk-list">
                    <li
                        v-for="category in section_columns(section)"
                        :key="category.id"
                        class="uk-margin-small-bottom"
                    >
                        <label :class="{'uk-text-bold': selectedIds.indexOf(category.id) >= 0}">
                            <input
                                type="checkbox"
                                name="category_id"
                                :checked="selectedIds.indexOf(category.id) >= 0"
                                :disabled="!toggable(category)"
                                @change="toggle($event, category)"
                            >
                            {{ category.name }}
                        </label>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<style lang="less">
    .lam-hierarchical-lists {
        & > ul.uk-list {
            column-count: 4;

            & > li {
                display: inline-block;
                width: 100%;
            }
        }
    }
    /*
    .lam-hierarchical-lists {
        display: flex;
        flex-wrap: wrap;
        max-height: 500px;

        & > ul.uk-list {
            margin: 0;
            flex: 1 1 auto;
        }
    }
    */
</style>

<script type="text/javascript">
import { mapGetters } from "vuex"
import { orderBy } from "lodash"

export default {
    name: "category-picker-list",
    computed: {
        ...mapGetters(["entity_records", "entity_record"]),
        raw_category_records () {
            return this.entity_records("category")
        },
        categories () {
            return Object.values(this.raw_category_records)
        },
        filtered_categories () {
            // if(!!this.filtered && (this.filtered === "overhead")) return this.categories.filter(category => !!category.name.match(/^lam\s/i))
            return this.categories
        },
        sections () {
            const sections = []
            this.filtered_categories.forEach(category => {
                if(sections.indexOf(category.section) < 0) sections.push(category.section)
            })
            const priorities = ["", "General Types", "Building / Space Types", "Project & Construction Types", "Lam Labs"]
            return sections.sort((section_a, section_b) => {
                const priority_a = priorities.indexOf(section_a)
                const priority_b = priorities.indexOf(section_b)

                if((priority_a < 0) && (priority_b >= 0)) return 1
                if((priority_a >= 0) && (priority_b < 0)) return -1

                return (priority_a + 1) - (priority_b + 1)
            })
        }
    },
    methods: {
        section_columns (section) {
            return orderBy(this.filtered_categories.filter(category => category.section === section), ["name"], ["asc"])
            /*
            let columns = [[]]
            let column_index = 0
            const section_categories = orderBy(this.filtered_categories.filter(category => category.section===section), ["name"], ["asc"])
            const per_column = Math.min(Math.ceil(section_categories.length / this.nbColumns), this.rowsPerColumn)

            section_categories.forEach(category => {
                if(columns[column_index].length >= per_column) {
                    columns.push([])
                    column_index++
                }
                columns[column_index].push(category)
            })

            return columns
            */
        },
        toggle ($event, category) {
            this.$emit("pick", $event.target.checked, category.id)
        },
        toggable (category) {
            if(this.requiredSections.length && (this.requiredSections.indexOf(category.section) >= 0) && (this.selectedIds.indexOf(category.id) >= 0)) {
                const section_selected_ids = this.selectedIds.filter(id => {
                    const selected_category = this.entity_record("category", id)
                    return !!selected_category && (selected_category.section === category.section)
                })
                return (section_selected_ids.length > 1)
            }
            return true
        }
    },
    props: {
        selectedIds: {
            type: Array,
            required: true
        },
        level: {
            default: 0
        },
        filtered: {
            type: String,
            default: "" // "overhead", "regular"
        },
        nbColumns: {
            type: Number,
            default: 5
        },
        rowsPerColumn: {
            type: Number,
            default: 20
        },
        requiredSections: {
            type: Array,
            default () {
                return ["General Types"]
            }
        }
    }
}
</script>
